import React from 'react'

const LangSelectModal = ({handleChange ,selectedLangCode}) => {
  return (   
    <div>
        <label htmlFor="" className='form-label'>اللغة</label>
        <select name="" id="" onChange={handleChange} value={selectedLangCode} className='form-select'>
            <option value="ar">العربية</option>
            <option value="en">English</option>
        </select>
    </div>
  )
}

export default LangSelectModal